/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux';
import { RootState } from '../configureStore';
import { BillableInsightsSummary, FinancialPerformanceSummary } from '../../data/types/insightsTypes';

export type InsightsState = {
    billableInsightsSummary: BillableInsightsSummary,
    financialPerformanceSummary: FinancialPerformanceSummary,
}

export const useInsightsState = () => {
    const insightsState = useSelector((state: RootState | any) => state.insights as InsightsState);
    return insightsState;
}

// Define the initial state using that type
const initialState: InsightsState = {
    billableInsightsSummary: {} as BillableInsightsSummary,
    financialPerformanceSummary: {} as FinancialPerformanceSummary,
}

export const insightsSlice = createSlice({
    name: 'insights',
    initialState: initialState,
    reducers: {
        setBillableInsightsSummaryAction: (state, action: PayloadAction<BillableInsightsSummary>) => {
            state.billableInsightsSummary = action.payload;
        },
        setFinancialPerformanceSummaryAction: (state, action: PayloadAction<FinancialPerformanceSummary>) => {
            state.financialPerformanceSummary = action.payload;
        },
    }
})

export const { setBillableInsightsSummaryAction, setFinancialPerformanceSummaryAction } = insightsSlice.actions;

export default insightsSlice.reducer;